import { Routes, Route } from 'react-router-dom'
import CreatorDashboard from './CreatorDashboard'
import Upload from './Upload'
import Portfolio from './Portfolio'
import Analytics from './Analytics'
import NFTs from './NFTs'
import Settings from './Settings'
import MediaRecordPage from '../MediaRecordPage'

const CreatorStudio: React.FC = () => {
  return (
    <Routes>
      <Route index element={<CreatorDashboard />} />
      <Route path="upload" element={<Upload />} />
      <Route path="portfolio" element={<Portfolio />} />
      <Route path="analytics" element={<Analytics />} />
      <Route path="nfts" element={<NFTs />} />
      <Route path="settings" element={<Settings />} />
      <Route path="media/:mediaId" element={<MediaRecordPage />} />
    </Routes>
  )
}

export default CreatorStudio 